/* Copyright (c) 2019, FIRST.ORG, INC.
 * CVSS 3.1 Calculator
 */

var CVSS31 = {};

CVSS31.CVSSVersionIdentifier = "CVSS:3.1";
CVSS31.exploitabilityCoefficient = 8.22;
CVSS31.scopeCoefficient = 1.08;

CVSS31.vectorStringRegex_31 =
  /^CVSS:3\.1\/((AV:[NALP]|AC:[LH]|PR:[UNLH]|UI:[NR]|S:[UC]|[CIA]:[NLH]|E:[XUPFH]|RL:[XOTWU]|RC:[XURC]|[CIA]R:[XLMH]|MAV:[XNALP]|MAC:[XLH]|MPR:[XUNLH]|MUI:[XNR]|MS:[XUC]|M[CIA]:[XNLH])\/)*(AV:[NALP]|AC:[LH]|PR:[UNLH]|UI:[NR]|S:[UC]|[CIA]:[NLH]|E:[XUPFH]|RL:[XOTWU]|RC:[XURC]|[CIA]R:[XLMH]|MAV:[XNALP]|MAC:[XLH]|MPR:[XUNLH]|MUI:[XNR]|MS:[XUC]|M[CIA]:[XNLH])$/;

CVSS31.Weight = {
  AV: { N: 0.85, A: 0.62, L: 0.55, P: 0.2 },
  AC: { H: 0.44, L: 0.77 },
  PR: {
    U: { N: 0.85, L: 0.62, H: 0.27 },
    C: { N: 0.85, L: 0.68, H: 0.5 },
  },
  UI: { N: 0.85, R: 0.62 },
  S: { U: 6.42, C: 7.52 },
  CIA: { N: 0, L: 0.22, H: 0.56 },
  E: { X: 1, U: 0.91, P: 0.94, F: 0.97, H: 1 },
  RL: { X: 1, O: 0.95, T: 0.96, W: 0.97, U: 1 },
  RC: { X: 1, U: 0.92, R: 0.96, C: 1 },
  CIAR: { X: 1, L: 0.5, M: 1, H: 1.5 },
};

CVSS31.severityRatings = [
  { name: "None", bottom: 0.0, top: 0.0 },
  { name: "Low", bottom: 0.1, top: 3.9 },
  { name: "Medium", bottom: 4.0, top: 6.9 },
  { name: "High", bottom: 7.0, top: 8.9 },
  { name: "Critical", bottom: 9.0, top: 10.0 },
];

CVSS31.calculateCVSSFromMetrics = function (
  AttackVector, AttackComplexity, PrivilegesRequired, UserInteraction,
  Scope, Confidentiality, Integrity, Availability,
  ExploitCodeMaturity, RemediationLevel, ReportConfidence,
  ConfidentialityRequirement, IntegrityRequirement, AvailabilityRequirement,
  ModifiedAttackVector, ModifiedAttackComplexity, ModifiedPrivilegesRequired,
  ModifiedUserInteraction, ModifiedScope, ModifiedConfidentiality,
  ModifiedIntegrity, ModifiedAvailability
) {
  var badMetrics = [];

  if (typeof AttackVector === "undefined" || AttackVector === "") badMetrics.push("AV");
  if (typeof AttackComplexity === "undefined" || AttackComplexity === "") badMetrics.push("AC");
  if (typeof PrivilegesRequired === "undefined" || PrivilegesRequired === "") badMetrics.push("PR");
  if (typeof UserInteraction === "undefined" || UserInteraction === "") badMetrics.push("UI");
  if (typeof Scope === "undefined" || Scope === "") badMetrics.push("S");
  if (typeof Confidentiality === "undefined" || Confidentiality === "") badMetrics.push("C");
  if (typeof Integrity === "undefined" || Integrity === "") badMetrics.push("I");
  if (typeof Availability === "undefined" || Availability === "") badMetrics.push("A");

  if (badMetrics.length > 0) {
    return { success: false, errorType: "MissingBaseMetric", errorMetrics: badMetrics };
  }

  var AV = AttackVector, AC = AttackComplexity, PR = PrivilegesRequired;
  var UI = UserInteraction, S = Scope, C = Confidentiality, I = Integrity, A = Availability;
  var E = ExploitCodeMaturity || "X", RL = RemediationLevel || "X", RC = ReportConfidence || "X";
  var CR = ConfidentialityRequirement || "X", IR = IntegrityRequirement || "X", AR = AvailabilityRequirement || "X";
  var MAV = ModifiedAttackVector || "X", MAC = ModifiedAttackComplexity || "X";
  var MPR = ModifiedPrivilegesRequired || "X", MUI = ModifiedUserInteraction || "X";
  var MS = ModifiedScope || "X", MC = ModifiedConfidentiality || "X";
  var MI = ModifiedIntegrity || "X", MA = ModifiedAvailability || "X";

  var metricWeightAV = CVSS31.Weight.AV[AV];
  var metricWeightAC = CVSS31.Weight.AC[AC];
  var metricWeightPR = CVSS31.Weight.PR[S][PR];
  var metricWeightUI = CVSS31.Weight.UI[UI];
  var metricWeightS = CVSS31.Weight.S[S];
  var metricWeightC = CVSS31.Weight.CIA[C];
  var metricWeightI = CVSS31.Weight.CIA[I];
  var metricWeightA = CVSS31.Weight.CIA[A];
  var metricWeightE = CVSS31.Weight.E[E];
  var metricWeightRL = CVSS31.Weight.RL[RL];
  var metricWeightRC = CVSS31.Weight.RC[RC];
  var metricWeightCR = CVSS31.Weight.CIAR[CR];
  var metricWeightIR = CVSS31.Weight.CIAR[IR];
  var metricWeightAR = CVSS31.Weight.CIAR[AR];
  var metricWeightMAV = CVSS31.Weight.AV[MAV !== "X" ? MAV : AV];
  var metricWeightMAC = CVSS31.Weight.AC[MAC !== "X" ? MAC : AC];
  var metricWeightMPR = CVSS31.Weight.PR[MS !== "X" ? MS : S][MPR !== "X" ? MPR : PR];
  var metricWeightMUI = CVSS31.Weight.UI[MUI !== "X" ? MUI : UI];
  var metricWeightMS = CVSS31.Weight.S[MS !== "X" ? MS : S];
  var metricWeightMC = CVSS31.Weight.CIA[MC !== "X" ? MC : C];
  var metricWeightMI = CVSS31.Weight.CIA[MI !== "X" ? MI : I];
  var metricWeightMA = CVSS31.Weight.CIA[MA !== "X" ? MA : A];

  var iss = 1 - (1 - metricWeightC) * (1 - metricWeightI) * (1 - metricWeightA);
  var impact = S === "U" ? metricWeightS * iss : metricWeightS * (iss - 0.029) - 3.25 * Math.pow(iss - 0.02, 15);
  var exploitability = CVSS31.exploitabilityCoefficient * metricWeightAV * metricWeightAC * metricWeightPR * metricWeightUI;

  var baseScore;
  if (impact <= 0) {
    baseScore = 0;
  } else if (S === "U") {
    baseScore = CVSS31.roundUp1(Math.min(exploitability + impact, 10));
  } else {
    baseScore = CVSS31.roundUp1(Math.min(CVSS31.scopeCoefficient * (exploitability + impact), 10));
  }

  var temporalScore = CVSS31.roundUp1(baseScore * metricWeightE * metricWeightRL * metricWeightRC);

  var miss = Math.min(1 - (1 - metricWeightMC * metricWeightCR) * (1 - metricWeightMI * metricWeightIR) * (1 - metricWeightMA * metricWeightAR), 0.915);
  var modifiedImpact = (MS === "U" || (MS === "X" && S === "U"))
    ? metricWeightMS * miss
    : metricWeightMS * (miss - 0.029) - 3.25 * Math.pow(miss * 0.9731 - 0.02, 13);
  var modifiedExploitability = CVSS31.exploitabilityCoefficient * metricWeightMAV * metricWeightMAC * metricWeightMPR * metricWeightMUI;

  var envScore;
  if (modifiedImpact <= 0) {
    envScore = 0;
  } else if (MS === "U" || (MS === "X" && S === "U")) {
    envScore = CVSS31.roundUp1(CVSS31.roundUp1(Math.min(modifiedImpact + modifiedExploitability, 10)) * metricWeightE * metricWeightRL * metricWeightRC);
  } else {
    envScore = CVSS31.roundUp1(CVSS31.roundUp1(Math.min(CVSS31.scopeCoefficient * (modifiedImpact + modifiedExploitability), 10)) * metricWeightE * metricWeightRL * metricWeightRC);
  }

  var vectorString = CVSS31.CVSSVersionIdentifier + "/AV:" + AV + "/AC:" + AC + "/PR:" + PR + "/UI:" + UI + "/S:" + S + "/C:" + C + "/I:" + I + "/A:" + A;
  if (E !== "X") vectorString += "/E:" + E;
  if (RL !== "X") vectorString += "/RL:" + RL;
  if (RC !== "X") vectorString += "/RC:" + RC;
  if (CR !== "X") vectorString += "/CR:" + CR;
  if (IR !== "X") vectorString += "/IR:" + IR;
  if (AR !== "X") vectorString += "/AR:" + AR;
  if (MAV !== "X") vectorString += "/MAV:" + MAV;
  if (MAC !== "X") vectorString += "/MAC:" + MAC;
  if (MPR !== "X") vectorString += "/MPR:" + MPR;
  if (MUI !== "X") vectorString += "/MUI:" + MUI;
  if (MS !== "X") vectorString += "/MS:" + MS;
  if (MC !== "X") vectorString += "/MC:" + MC;
  if (MI !== "X") vectorString += "/MI:" + MI;
  if (MA !== "X") vectorString += "/MA:" + MA;

  return {
    success: true,
    baseMetricScore: baseScore.toFixed(1),
    baseSeverity: CVSS31.severityRating(baseScore.toFixed(1)),
    baseISS: iss,
    baseImpact: impact,
    baseExploitability: exploitability,
    temporalMetricScore: temporalScore.toFixed(1),
    temporalSeverity: CVSS31.severityRating(temporalScore.toFixed(1)),
    environmentalMetricScore: envScore.toFixed(1),
    environmentalSeverity: CVSS31.severityRating(envScore.toFixed(1)),
    environmentalMISS: miss,
    environmentalModifiedImpact: modifiedImpact,
    environmentalModifiedExploitability: modifiedExploitability,
    vectorString: vectorString,
  };
};

CVSS31.calculateCVSSFromVector = function (vectorString) {
  var metricValues = {
    AV: undefined, AC: undefined, PR: undefined, UI: undefined, S: undefined,
    C: undefined, I: undefined, A: undefined, E: undefined, RL: undefined,
    RC: undefined, CR: undefined, IR: undefined, AR: undefined, MAV: undefined,
    MAC: undefined, MPR: undefined, MUI: undefined, MS: undefined, MC: undefined,
    MI: undefined, MA: undefined,
  };

  if (!CVSS31.vectorStringRegex_31.test(vectorString)) {
    return { success: false, errorType: "MalformedVectorString" };
  }

  var metricNameValue = vectorString.substring(CVSS31.CVSSVersionIdentifier.length).split("/");
  var badMetrics = [];

  for (var i in metricNameValue) {
    if (metricNameValue.hasOwnProperty(i)) {
      var singleMetric = metricNameValue[i].split(":");
      if (typeof metricValues[singleMetric[0]] === "undefined") {
        metricValues[singleMetric[0]] = singleMetric[1];
      } else {
        badMetrics.push(singleMetric[0]);
      }
    }
  }

  if (badMetrics.length > 0) {
    return { success: false, errorType: "MultipleDefinitionsOfMetric", errorMetrics: badMetrics };
  }

  return CVSS31.calculateCVSSFromMetrics(
    metricValues.AV, metricValues.AC, metricValues.PR, metricValues.UI,
    metricValues.S, metricValues.C, metricValues.I, metricValues.A,
    metricValues.E, metricValues.RL, metricValues.RC, metricValues.CR,
    metricValues.IR, metricValues.AR, metricValues.MAV, metricValues.MAC,
    metricValues.MPR, metricValues.MUI, metricValues.MS, metricValues.MC,
    metricValues.MI, metricValues.MA
  );
};

CVSS31.roundUp1 = function (input) {
  var int_input = Math.round(input * 100000);
  return int_input % 10000 === 0 ? int_input / 100000 : (Math.floor(int_input / 10000) + 1) / 10;
};

CVSS31.severityRating = function (score) {
  var validatedScore = Number(score);
  if (isNaN(validatedScore)) return validatedScore;
  for (var i = 0; i < CVSS31.severityRatings.length; i++) {
    if (score >= CVSS31.severityRatings[i].bottom && score <= CVSS31.severityRatings[i].top) {
      return CVSS31.severityRatings[i].name;
    }
  }
  return undefined;
};

export default CVSS31;
